import Axios from "axios";
var TakeStockService = (function () {
    function TakeStockService() {
    }
    TakeStockService.createInstance = function () {
        TakeStockService.getInstance();
    };
    TakeStockService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    TakeStockService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/inventoryorder/list", { params: params });
    };
    TakeStockService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/inventoryorder/detail", { params: params });
    };
    TakeStockService.prototype.addUpperwarehouse = function (params) {
        return Axios.post("supplierclientapi/inventoryorder/save_order", params);
    };
    TakeStockService.prototype.getSupplierdepotList = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/list", { params: params });
    };
    TakeStockService.prototype.audit = function (params) {
        return Axios.get("supplierclientapi/inventoryorder/do_audit", { params: params });
    };
    TakeStockService.prototype.discard = function (params) {
        return Axios.get("supplierclientapi/inventoryorder/do_cancel", { params: params });
    };
    TakeStockService.prototype.getOrgandepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_organdepot_options", { params: params });
    };
    TakeStockService.prototype.getSupplierupperOptions = function (params) {
        return Axios.get("supplierclientapi/supplierupper/get_options", { params: params });
    };
    TakeStockService.prototype.getAccountOptions = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    TakeStockService.prototype.getSupplierorganOptions = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    TakeStockService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    TakeStockService.prototype.getStockinitGoodslist = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/get_stock_goods_list", params);
    };
    TakeStockService.prototype.getStockinitGoodsOrlist = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/get_goods_or_stock_list", params);
    };
    TakeStockService.prototype.deleteStockinitGoodslist = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/delete_detail", { params: params });
    };
    TakeStockService.prototype.stockExport = function (params) {
        return Axios.get("supplierclientapi/inventoryorder/export_detail", { params: params });
    };
    return TakeStockService;
}());
export default TakeStockService;
